import { Box, Container, Stack, Typography } from '@mui/material';
import { Header } from '../../../components/Header';

/**
 * Not FoundページのContainer Component
 */
export const NotFoundContainer: React.FC = () => (
  <>
    <Header showLoginButton={false} />
    <Stack direction="column" maxWidth="sm" mx="auto">
      <Box flexGrow={1} py={4}>
        <Container>
          <Typography>ページが見つかりません。</Typography>
        </Container>
      </Box>
    </Stack>
  </>
);
